<template>
  <pp-expansion-panels
    v-model="model"
    active-class="pp-collapse--active"
  >
    <pp-expansion-panel
      :title="label"
      :loading="false"
      :disable-icon-rotate="true"
      :custom-icon="getIconClass"
      class="pp-collapse mx-0 my-0 grey--text text--darken-4"
    >
      <template slot="content">
        <slot />
      </template>
    </pp-expansion-panel>
  </pp-expansion-panels>
</template>

<script>

export default {
  name: 'CollapseItem',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      model: this.value ? 0 : null
    }
  },
  computed: {
    getIconClass () {
      return this.model === 0 ? 'subtract' : 'plus'
    }
  },
  watch: {
    value (newVal) {
      this.model = newVal ? 0 : null
    },
    model (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      this.$emit('input', newVal === 0)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .pp-collapse {
    border: none;
    max-width: none;
    outline: none;

    &:before {
      content: none;
    }

    .v-expansion-panel-header {
      min-height: 52px;
      padding: 8px 0;
    }

    .v-expansion-panel-content__wrap { /* stylelint-disable-line selector-class-pattern */
      padding: 0;
    }

    &--active {
      & > .v-expansion-panel-header {
        min-height: 52px;
      }
    }
  }
}
</style>
